import LogDecorator from '../../ada/ada/services/logDecorator';

// @ngInject
function OnConfig($stateProvider, $locationProvider, $urlRouterProvider, x2jsProvider, $provide,
    $controllerProvider, $compileProvider, $filterProvider, LightboxProvider, AnalyticsProvider) {
    x2jsProvider.config = {
        arrayAccessFormPaths: [
            "Inspection.InspectionItems.InspectionItem",
            "Inspection.InspectionItems.Form.Sections.FormSection",
            "Inspection.InspectionItems.Form.Sections.FormSection.Recommendations.Recommendation"
        ],
        skipEmptyTextNodesForObj: false
        /*
        escapeMode               : true|false - Escaping XML characters. Default is true from v1.1.0+
        attributePrefix          : "<string>" - Prefix for XML attributes in JSon model. Default is "_"
        arrayAccessForm          : "none"|"property" - The array access form (none|property). Use this property if you want X2JS generates an additional property <element>_asArray to access in array form for any XML element. Default is none from v1.1.0+
        emptyNodeForm            : "text"|"object" - Handling empty nodes (text|object) mode. When X2JS found empty node like <test></test> it will be transformed to test : '' for 'text' mode, or to Object for 'object' mode. Default is 'text'
        enableToStringFunc       : true|false - Enable/disable an auxiliary function in generated JSON objects to print text nodes with text/cdata. Default is true
        arrayAccessFormPaths     : [] - Array access paths. Use this option to configure paths to XML elements always in "array form". You can configure beforehand paths to all your array elements based on XSD or your knowledge. Every path could be a simple string (like 'parent.child1.child2'), a regex (like /.*\.child2/), or a custom function. Default is empty
        skipEmptyTextNodesForObj : true|false - Skip empty text tags for nodes with children. Default is true.
        stripWhitespaces         : true|false - Strip whitespaces (trimming text nodes). Default is true.
        datetimeAccessFormPaths  : [] - Datetime access paths. Use this option to configure paths to XML elements for "datetime form". You can configure beforehand paths to all your array elements based on XSD or your knowledge. Every path could be a simple string (like 'parent.child1.child2'), a regex (like /.*\.child2/), or a custom function. Default is empty
        */
    };

    LightboxProvider.calculateImageDimensionLimits = function (dimensions) {
        return {
            'maxWidth': 600,
            'maxHeight': 600
        };
    };

    //Google Analytics AccountInfo
    AnalyticsProvider.setAccount('UA-91328645-2');


    window.register = {
        controller: $controllerProvider.register,
        directive: $compileProvider.directive,
        filter: $filterProvider.register,
        factory: $provide.factory
    };
    
    // $locationProvider.html5Mode(true);
    $urlRouterProvider.otherwise('/');

    var logDecorator = LogDecorator('yyyy-MM-ddTHH:mm:ss');
    $provide.decorator('$log', logDecorator.decorator);

    $stateProvider
        .state('confirm', {
            url: '/confirm?token',
            controller: 'InvitationCtrl',
            templateUrl: 'controllers/invitation/invitation.html'
        })
        .state('login', {
            url: '/login?res&id&assetType',
            controller: 'LoginCtrl',
            templateUrl: 'controllers/login/login.html'
        })
        .state('forgotPassword', {
            url: '/forgotpassword',
            controller: 'ForgotPasswordCtrl',
            templateUrl: 'controllers/login/forgotPassword.html'
        })        
        .state('adminLogin', {
            url: '/admin',
            controller: 'LoginCtrl',
            templateUrl: 'controllers/login/login.html'
        })
        .state('admin', {
            url: '',
            abstract: true,
            controller: 'AdminCtrl',
            templateUrl: 'controllers/app/admin.html'
        })
        .state('admin.home', {
            url: '/home',
            views: {
                'content': {
                    controller: 'AdminHomeCtrl',
                    templateUrl: 'controllers/admin/adminHome.html'
                }
            }
        })
        .state('admin.captions', {
            url: '/captions',
            views: {
                'content':
                {
                    controller: 'CaptionsCtrl',
                    templateUrl: 'controllers/captions/captions.html'
                }
            }
        })
        .state('admin.assets', {
            url: '/assets',
            views: {
                'content':
                {
                    controller: 'AssetListCtrl',
                    templateUrl: 'controllers/assets/assets.html'
                }
            }
        })
        .state('admin.addAsset', {
            url: '/assets/new',
            views: {
                'content':
                {
                    controller: 'AssetCtrl',
                    templateUrl: 'controllers/assets/assetForm.html'
                }
            }
        })
        .state('admin.legal', {
            url: '/legal',
            views: {
                'content':
                {
                    controller: 'LegalCtrl',
                    templateUrl: 'controllers/legal/legal.html'
                }
            }
        })    
        .state('admin.analytics', {
            url: '/analytics/google',
            views: {
                'content':
                {
                    controller: 'GoogleAnalyticsCtrl',
                    templateUrl: 'controllers/analytics/googleAnalytics.html'
                }
            }
        })  
        .state('admin.reports', {
            url: '/reports',
            views: {
                'content':
                {
                    controller: 'ReportsCtrl',
                    templateUrl: 'controllers/analytics/reports.html'
                }
            }
        })                           
        .state('admin.asset', {
            url: '/assets/:id',
            views: {
                'content':
                {
                    controller: 'AssetCtrl',
                    templateUrl: 'controllers/assets/assetForm.html'
                }
            }
        })
        .state('app', {
            url: '',
            abstract: true,
            controller: 'AppCtrl',
            templateUrl: 'controllers/app/app.html'
        })
        .state('app.home', {
            url: '/',
            views: {
                'content': {
                    controller: 'HomeCtrl',
                    templateUrl: 'controllers/home/home.html'
                }
            }
        })
        .state('app.recs', {
            url: '/recs',
            views: {
                'content': {
                    controller: 'RecsCtrl',
                    templateUrl: 'controllers/recs/recs.html'
                }
            }
        })
        .state('app.rec', {
            url: '/recs/:id',
            views: {
                'content': {
                    controller: 'RecEditCtrl',
                    templateUrl: 'controllers/recs/form.html'
                }
            }
        })
        .state('app.visits', {
            url: '/visits',
            views: {
                'content': {
                    controller: 'VisitsCtrl',
                    templateUrl: 'controllers/visits/visits.html'
                }
            }
        })
        .state('app.visit', {
            url: '/visits/:id',
            views: {
                'content': {
                    controller: 'VisitFormCtrl',
                    templateUrl: 'controllers/visits/visitForm.html'
                }
            }
        })        
        .state('app.communications', {
            url: '/visits/:id/communications',
            views: {
                'content': {
                    controller: 'CommunicationsCtrl',
                    templateUrl: 'controllers/communications/communications.html'
                }
            }
        })        
        .state('app.resources', {
            url: '/resources',
            views: {
                'content': {
                    controller: 'ResourcesCtrl',
                    templateUrl: 'controllers/resources/resources.html'
                }
            }
        })
        .state('app.account', {
            url: '/account',
            views: {
                'content': {
                    controller: 'AccountCtrl',
                    templateUrl: 'controllers/account/account.html'
                }
            }
        })
        ;
}

export default OnConfig;
